import { render, staticRenderFns } from "./employeeWorkloaddetails.vue?vue&type=template&id=30463d92"
import script from "./employeeWorkloaddetails.vue?vue&type=script&lang=js"
export * from "./employeeWorkloaddetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports